// Styles for MerchandisingSerpBanner go here.
import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
const { lg, md } = { ...baseVariables.mediaQuery };

export const StyledMerchandisingSerpBanner = styled.div`
  .merchandising-serp-banner {
    border-radius: 16px;
    box-shadow: ${baseVariables.shadows['shadowSubtle01']};
    overflow: hidden;

    &__image_container {
      position: relative;
      width: 100%;
      @media ${md} {
        width: 50%;
      }

      @media ${lg} {
        width: 44%;
      }
    }

    &__image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      aspect-ratio: 3 / 2;

      @media ${lg} {
        aspect-ratio: 16/ 9;
      }

      &-logo {
        position: absolute;
        left: 16px;
        bottom: 16px;
        max-width: 200px;
      }
    }

    &__content {
      width: 100%;

      @media ${md} {
        width: 50%;
      }

      @media ${lg} {
        width: 56%;
      }

      &-badge {
        border-radius: 4px;

        &.skeleton-loader {
          max-width: 100px;
        }
      }

      &-bullets {
        .skeleton-loader {
          max-width: 60%;
        }

        .icon-success::before {
          max-height: 16px;
        }
      }
    }
  }
`;
